export const timeEntrybyLocationId = /* GraphQL */ `
    query CustomTimeEntrybyLocationId(
        $locationId: ID!
        $date: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeEntryFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeEntrybyLocationId(locationId: $locationId, date: $date, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                scopeId
                scope {
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    name
                }
                crewMemberId
                crewMember {
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const timeEntrybyScopeId = /* GraphQL */ `
    query CustomTimeEntrybyScopeId(
        $scopeId: ID!
        $locationId: ModelIDKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeEntryFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeEntrybyScopeId(scopeId: $scopeId, locationId: $locationId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                scopeId
                scope {
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    name
                }
                crewMemberId
                crewMember {
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const timeEntrybyCrewMemberId = /* GraphQL */ `
    query CustomTimeEntrybyCrewMemberId(
        $crewMemberId: ID!
        $locationId: ModelIDKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeEntryFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeEntrybyCrewMemberId(
            crewMemberId: $crewMemberId
            locationId: $locationId
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                date
                syncStatusMessage
                status
                scopeId
                scope {
                    id
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    id
                    name
                }
                crewMemberId
                crewMember {
                    id
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const timeEntrybyCustomerId = /* GraphQL */ `
    query TimeEntrybyCustomerId(
        $customerId: ID!
        $locationId: ModelIDKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeEntryFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeEntrybyCustomerId(customerId: $customerId, locationId: $locationId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                scopeId
                scope {
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    name
                }
                crewMemberId
                crewMember {
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                __typename
            }
            nextToken
            __typename
        }
    }
`;
export const timeEntrybyStatus = /* GraphQL */ `
    query CustomTimeEntrybyStatus(
        $status: TimeEntryStatus!
        $locationId: ModelIDKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeEntryFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeEntrybyStatus(status: $status, locationId: $locationId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                scopeId
                scope {
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    name
                }
                crewMemberId
                crewMember {
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                status
                syncStatusMessage
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const timeSheetByForemanId = /* GraphQL */ `
  query CustomTimeSheetByForemanId(
    $foremanId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByForemanId(
      foremanId: $foremanId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        customer {
            name
        }
        timeEntries {
            items {
                id
                date
                scopeId
                scope {
                    name
                }
                hours
                adjustedHours {
                    straightTime
                    overtime
                }
                isApproved
                timeSheetId
                customerId
                customer {
                    name
                }
                crewMemberId
                crewMember {
                    name
                    rate
                    active
                    rateOverride {
                        rate
                    }
                }
                locationId
                status
                syncStatusMessage
            }
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;